export default __webpack_public_path__ + "static/thinking-in-bets-d5edc74608ddb20e2ea0260a9c8cf135.jpg";